<template>
  <div v-if="value">
    <b-row>
      <b-col cols="12" class="pt-3 pb-2">
        <b-form-group label="Status" label-class="pb-0 mb-0">
          <b-form-select v-model="status" :options="options[role]"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="pb-3">
      <b-col>
        <b-button
          variant="primary"
          class="float-right px-5"
          @click="$emit('input', status)"
        >Update</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    role: {
      type: String,
      default: 'mentor',
    },
  },
  watch: {
    value() {
      this.status = this.value;
    },
  },
  created() {
    this.status = this.value;
  },
  data: () => ({
    err: null,
    status: '',
    options: {
      mentor: [
        'ACTIVE',
        'HIDDEN',
      ],
      admin: [
        'REJECTED',
        'ACTIVE',
        'INACTIVE',
      ],
    },
  }),
};
</script>



// WEBPACK FOOTER //
// src/components/mentors/UpdateMentorStatusForm.vue